<template>
  <div id="app">
    <div class="container">
        <GdashMap :palette="palette" :dataService="dataService" v-on:dataChanged="dataChanged" > </GdashMap>
      <div class="data">
        <div class="row">
          <div class="data-group" v-if="data" v-show="data">
            <div class="group">
              <div class="group-title">{{name}}</div>
            </div>

            <wj-tab-panel :selectedIndex="0">
              <wj-tab>
                <a href="#">Demographics</a>
                <div>
                  <div class="data-col">
                    <PopulationTile :data="data" :palette="palette">
                    </PopulationTile>
                  </div>
                  <div class="data-col">
                    <MedianAgeTile :data="data" :palette="palette">
                    </MedianAgeTile>
                  </div>
                </div>
              </wj-tab>
              <wj-tab>
                <a href="#">Affluence</a>
                <div>
                  <div class="data-col">
                    <NetWorthTile :data="data" :palette="palette">
                    </NetWorthTile>
                  </div>
                  <div class="data-col">
                    <HouseholdIncomeTile :data="data" :palette="palette">
                    </HouseholdIncomeTile>
                   </div>
                </div>
              </wj-tab>
              <wj-tab>
                <a href="#">Home Value</a>
                <div>
                  <div class="data-col">
                    <HomeValueTile :name="name" :data="data" :dataUS="dataUS"  :palette="palette">
                    </HomeValueTile>
                  </div>
                </div>
              </wj-tab>
            </wj-tab-panel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@mescius/wijmo.styles/wijmo.css";

import * as wjcCore from "@mescius/wijmo";
import "@mescius/wijmo.vue2.chart";
import "@mescius/wijmo.vue2.gauge";
import "@mescius/wijmo.vue2.nav";
import "@mescius/wijmo.vue2.chart.animation";
import "@mescius/wijmo.vue2.chart.map";

import HomeValueTile from "./components/HomeValueTile.vue";
import HouseholdIncomeTile from "./components/HouseholdIncomeTile.vue";
import NetWorthTile from "./components/NetWorthTile.vue";
import MedianAgeTile from "./components/MedianAgeTile.vue";
import PopulationTile from "./components/PopulationTile.vue";

import GdashMap from "./components/GdashMap.vue";
import DataService from "./services/DataService";

export default {
  name: "app",
  components: {
    HomeValueTile,
    HouseholdIncomeTile,
    NetWorthTile,
    MedianAgeTile,
    PopulationTile,
    GdashMap,
  },
  data: function () {
    return {
      palette: ["#00b075", "#f8ce45", "#ecf0ee"],
      data: null,
      dataUS: null,
      name: ""
    };
  },
  beforeCreate() {
    this.dataService = new DataService();
  },
  mounted() {
    this.dataService.init(() => 
    {
      this.data = this.dataUS = this.dataService.getData(0);
      this.name = "US";
    });
  },
  methods: {
    dataChanged(data, name) {
      this.data = data;
      this.name = name;
    },
  },
  filters: {
    format(value, format) {
      return wjcCore.Globalize.format(value, format);
    },
  },
};
</script>

<style>
/* app */
*,
::after,
::before {
  box-sizing: border-box;
}

body,
html {
  height: 100%;
  margin: 0;
}

body {
  color: #7e8989;
  font-family: -apple-system-font, "Segoe UI", "Roboto", sans-serif;
  font-size: 0.875rem;
  display: flex;
  flex-direction: column;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: -apple-system-font, "Segoe UI Light", "Segoe UI", "Roboto",
    sans-serif;
  font-weight: 300;
}

b {
  font-weight: 500;
  color: black;
}

[type="button"]:not(:disabled),
button:not(:disabled) {
  cursor: pointer;
}

#app {
  flex: 1 1 auto;
  overflow: hidden;
}

.container {
  display: flex;
  flex-direction: row;
  height: 100%;
}
@media only screen and (max-width: 900px) {
  .container {
    flex-direction: column;
  }
}

.map {
  position: relative;
  flex: 1 1 60%;
  min-width: 0;
}
@media only screen and (max-width: 900px) {
  .map {
    flex: 1 1 30%;
    min-height: 300px;
  }
}

.legend {
  position: absolute;
  bottom: 3rem;
  z-index: 1;
  left: 5rem;
  width: 210px;
  font-size: 0.875rem;
}
@media only screen and (max-width: 900px) {
  .legend {
    top: auto;
    bottom: 0.5rem;
    left: 0.5rem;
    right: auto;
    width: 60%;
    z-index: 2;
  }
}

.legend .legend-list {
  background: rgba(56, 60, 58, 0.9);
  padding: 1rem;
  border-radius: 0.25rem;
  margin-bottom: 0.25rem;
  color: #cecece;
}
@media only screen and (max-width: 900px) {
  .legend .legend-list {
    padding: 0.5rem;
    position: absolute;
    top: 32px;
    width: 100%;
    border-radius: 0;
  }
}

.legend .legend-item {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.legend .legend-item:not(:last-child) {
  margin-bottom: 0.5rem;
}

.legend .legend-select {
  font-size: inherit;
}
@media only screen and (max-width: 900px) {
  .legend .legend-select {
    border-bottom: none;
    border-left: none;
    border-right: none;
    border-radius: 0;
    background: rgba(255, 255, 255, 0.5);
  }
  .legend .legend-select:focus {
    outline: none;
  }
}

.data {
  position: relative;
  flex: 1 1 40%;
  overflow: auto;
  max-width: 600px;
  min-width: 500px;
  box-shadow: 0 0 3px -2px rgba(0, 0, 0, 0.2), 0 0 4px 0 rgba(0, 0, 0, 0.14),
    0 0 8px 0 rgba(0, 0, 0, 0.12);
}
@media only screen and (max-width: 900px) {
  .data {
    flex: 1 1 70%;
    min-width: auto;
    max-width: 100%;
  }
}

.data::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.data::-webkit-scrollbar-track {
  border-radius: 0.25rem;
  background: rgba(0, 0, 0, 0.1);
}
.data::-webkit-scrollbar-thumb {
  border-radius: 0.25rem;
  background: rgba(0, 0, 0, 0.2);
}
.data::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.4);
}
.data::-webkit-scrollbar-thumb:active {
  background: rgba(0, 0, 0, 0.9);
}

.data .data-row {
  display: flex;
  flex-direction: row;
}

.data .data-col {
  flex: 1 1 auto;
}

.group {
  padding: 2rem;
}

.group-title {
  color: black;
  font-size: 1.625rem;
  margin-bottom: 0.5rem;
}

.group-subtitle {
  color: #696969;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.group-description {
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.header {
  background-color: #00c1d5;
  background-position: 0 0;
  background-repeat: repeat-x;
  margin-bottom: 14px;
  padding: 12px 0px;
  color: #dcf3f6;
}

.header h1 {
  font-size: 40px;
  line-height: 1;
  margin-top: 0;
  color: #fff;
}

.header a {
  font-weight: bold;
  color: #dcf3f6;
}

/* information tiles */
.tile {
  padding: 2rem;
  font-size: 0.875rem;
}

.tile .tile-content {
  width: 100%;
}

.tile .tile-header {
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: black;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.tile .tile-header svg {
  width: 1rem;
  height: 1rem;
  opacity: 0.5;
  margin-right: 0.375rem;
}

.tile .tile-description {
  margin: 0.75rem 0 0;
  line-height: 1.5;
}

.tile .tile-chart {
  margin-top: 2.25rem;
}

.tile table {
  margin-top: 1.5rem;
  width: 100%;
  font-weight: 300;
}

.tile table tr td:last-child {
  width: 60%;
  color: black;
}

/* background images */
.symbol {
  width: 80px;
  height: 80px;
  text-align: center;
  background-repeat: no-repeat;
}

.chart {
  width: 100%;
  border: none;
  margin: 1.5rem 0 0;
  padding: 0;
  box-sizing: content-box;
}

.chart.chart-column {
  height: 240px;
}

.chart.chart-median {
  height: 240px;
}

.chart.chart-pie {
  border: none;
  max-width: 190px;
  max-height: 190px;
  margin: 0;
  padding: 0;
}

.chart.chart-bar {
  height: 160px;
  border: 1px solid #eee;
  padding: 0.5rem 1rem;
  margin: 0.5rem 0 0;
  font-size: 0.75rem;
  border-radius: 0.25rem;
  box-sizing: border-box;
}

.chart.chart-bar-stacked {
  height: 120px;
}

.gauge.gauge-linear {
  height: 0.75rem;
  font-size: 1rem;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-col {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: inherit;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  color: inherit;
  background-color: transparent;
  border-color: #d8dfe1;
  min-width: 6rem;
}

.btn:not(:disabled):not(.disabled).active,
.btn:not(:disabled):not(.disabled):active {
  color: #14a071;
  background-color: #d2f1e7;
  border-color: #d2f1e7;
  cursor: default;
}

.btn-group {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.btn-group > .btn {
  position: relative;
  flex: 1 1 auto;
}

.btn-group > .btn-group:not(:last-child) > .btn,
.btn-group > .btn:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group > .btn-group:not(:first-child) > .btn,
.btn-group > .btn:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group > .btn-group:not(:first-child),
.btn-group > .btn:not(:first-child) {
  margin-left: -1px;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}

.btn-group-toggle > .btn input[type="radio"],
.btn-group-toggle > .btn-group > .btn input[type="radio"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
  box-sizing: border-box;
  padding: 0;
}

.control-group {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.control-group-append {
  display: flex;
  margin-left: -1px;
}

.control-group-append .btn {
  position: relative;
  z-index: 2;
}

.control-group > .control-group-append > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.control-group > .control:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.control-group > .control:focus {
  z-index: 3;
}

.control-group > .control {
  position: relative;
  flex: 1 1 0%;
  min-width: 0;
  margin-bottom: 0;
}

.control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.control::focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.wj-control {
  color: inherit;
  background: inherit;
}

.wj-flexchart {
  display: block;
}

.wj-gauge .wj-min,
.wj-gauge .wj-max,
.wj-gauge .wj-tick-text text {
  font-size: 0.75em;
  opacity: 0.5;
}

.wj-gauge .wj-ticks {
  stroke-width: 1px;
  stroke: rgba(255, 255, 255, 0.8);
}

.wj-gauge .wj-face path {
  stroke: none;
}

.wj-tabheaders {
  margin: 0 1px;
  padding: 0 1.5rem;
  position: sticky;
  top: 0;
  background: white;
  border-bottom: 1px solid #ddd;
  z-index: 1;
}

.wj-tabpanel > div > .wj-tabpanes {
  border-top: none;
}

.wj-tabpanel > div > .wj-tabheaders > .wj-tabheader.wj-state-active {
  border-color: #ddd;
  border-bottom-color: transparent;
  color: black;
}

.wj-tabpanel > div > .wj-tabheaders > .wj-tabheader {
  top: 1px;
  border: 1px solid transparent;
  border-radius: 0.25rem 0.25rem 0 0;
  padding: 0.75rem 1rem;
  text-transform: none;
  font-weight: 500;
}
@media only screen and (max-width: 900px) {
  .wj-tabpanel > div > .wj-tabheaders > .wj-tabheader {
    padding: 0.5rem;
  }
}

.wj-tabpanel > div > .wj-tabheaders > .wj-tabheader:after {
  display: none;
}

div[style*="position: fixed; display: block; visibility: visible;"] {
  font-size: 0.75rem !important;
}

@media only screen and (max-width: 900px) {
  .universal-nav {
    white-space: nowrap;
  }
}

.gdash-gauge .wj-gauge {
  height: 26px;
  font-size: 0.75rem;
  width: 100%;
}

.gdash-gauge .wj-lineargauge .wj-value {
    fill: black;
}

.wj-flexmap {
  height: 100%;
  border: none;
}
</style>